"use client";

import { Input as HeroInput } from "@heroui/react";
import { cn } from "../../lib/utils";

export const Input = ({
  className,
  classNames,
  size,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroInput>) => {
  return (
    <HeroInput
      radius="sm"
      classNames={{
        ...classNames,
        input: cn(
          "placeholder:text-text-interactive-neutral-faint",
          size !== "lg" && "text-base sm:text-sm",
          classNames?.input,
        ),
        inputWrapper: cn(
          props.variant === "bordered" &&
            "border-1 border-border-interactive-neutral-default shadow-none data-[hover=true]:border-border-interactive-neutral-hover group-data-[focus-within=true]:border-border-interactive-neutral-selected group-data-[focus-within=true]:data-[hover=true]:border-border-interactive-neutral-selected",
          classNames?.inputWrapper,
        ),
      }}
      className={cn(className)}
      size={size}
      {...props}
    />
  );
};
